import OperatorInvoiceReport from "../../components/operator-invoice-report";
import HeaderPage from "../../components/lines-managements/header/HeaderPage";

const OperatorInvoiceReportPage: React.FC = () => {
  return (
    <>
      <HeaderPage hasNoInput />
      <OperatorInvoiceReport />
    </>
  );
};

export default OperatorInvoiceReportPage;
